export const en = {
    addToFavourite: 'Add to favorites',
    addedToFavourite: 'Added to favorites',
    permanentlyOutOfStockButtonText: 'Out of Stock',
    emailWhenInStockText: 'Email when in stock',
    addToBagText: 'Add to bag',
    reviewsText: 'reviews',
    wasText: 'Was',
    shippingText: 'Shipping',
    easyPayText: 'Easy Pay',
    sizeGuideIconAlt: 'Size Guide',
    sizeGuideSizeGuideText: 'Size guide',
    savingText: 'Savings',
    freeShipping: 'FREE SHIPPING',
    addReviewText: 'Add a review',
    paymentsOfText: 'Payments of',
    withText: 'with',
    orText: 'or',
    outOfStockText: 'Out of Stock',
    quantity: 'Quantity',
    quantityShort: 'Qty',
    only: 'Only ',
    left: ' left!',
    favoriteTooltip: 'Please sign in/register to add items to your Favorites list.',
    closeText: 'Close',
    colours: 'Colours',
    colour: 'Colour',
    style: 'Style',
    sizes: 'Sizes',
    size: 'Size',
    frequency: 'Frequency',
    recommendedSize: 'Recommended size',
    selectSize: 'Select size',
    selectStyle: 'Select style',
    selectSizeAndStyle: 'Select size & style',
    oneTimeShipment: '1 Time Shipment',
    autoDelivery: 'Auto Delivery',
    addedToBag: 'Added to bag',
    sizeGuideTitle: 'Size Guide',
    please: 'Please',
    signIn: 'sign in',
    register: 'register',
    toAddItemsToYourFavoritesList: 'to add items to your Favorites list.',
    brandText: 'Brand: {{brand}}',
    videoDesc: 'Pre-recorded videos contain pricing or promotional offers that may have expired.',
    autoPlayText: 'Autoplay Videos',
    autoPlayDisclaimerText:
        'You can switch this setting anytime by selecting the checkbox and we will remember your choice for any additional pages you view',
    'Sold and fulfilled by': 'Sold and fulfilled by',
};

export const fr = {
    addToFavourite: 'Ajouter aux Favoris',
    addedToFavourite: 'Ajouté aux Favoris',
    permanentlyOutOfStockButtonText: 'Out of Stock',
    emailWhenInStockText: 'Envoyez-moi un e-mail lorsque l’article est de nouveau en stock.',
    addToBagText: 'Ajouter au panier',
    reviewsText: 'commentaires',
    wasText: 'A été',
    shippingText: 'Expédition',
    easyPayText: 'Paiement facile',
    sizeGuideIconAlt: 'Guide des tailles',
    sizeGuideSizeGuideText: 'Guide des tailles',
    savingText: 'Économie',
    freeShipping: 'LIVRAISON GRATUITE',
    addReviewText: 'Ajouter un commentaire',
    paymentsOfText: 'Paiements de',
    withText: 'avec',
    orText: 'ou',
    outOfStockText: 'En Rupture de Stock',
    quantity: 'Quantité',
    quantityShort: 'Qté',
    only: 'Seulement ',
    left: ' en stock!',
    favoriteTooltip: 'Veuillez vous connecter ou vous inscrire pour ajouter des articles à votre liste de favoris.',
    closeText: 'Fermer',
    colours: 'Couleurs',
    colour: 'Couleur',
    style: 'Style',
    sizes: 'Tailles',
    size: 'Taille',
    recommendedSize: 'Taille recommandée',
    selectSize: 'Sélectionnez la taille',
    selectStyle: 'Select style',
    selectSizeAndStyle: 'Select size & style',
    addedToBag: 'Ajouté au panier',
    sizeGuideTitle: 'Guide des tailles',
    please: 'Veuillez vous',
    signIn: 'connecter',
    register: 'enregistrer',
    toAddItemsToYourFavoritesList: 'pour ajouter des articles à votre liste de favoris.',
    brandText: 'Marque : {{brand}}',
    autoPlayText: 'Vidéos en lecture automatique',
    autoPlayDisclaimerText:
        'Vous pouvez changer ce paramètre à tout moment en sélectionnant la case à cocheret nous nous souviendrons de votre choix pour toutes les pages supplémentaires que vous consultez.',
    videoDesc:
        'Les vidéos préenregistrées contiennent des prix ou des offres promotionnelles qui peuvent avoir expiré.',
    'Sold and fulfilled by': 'Vendu et expédié par',
};
